import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import debounce from 'lodash.debounce';
import { useGenerateInvoice } from 'api/invoices/use-generate-invoice';
import { useDownloadFile } from 'shared/hooks/use-download-file';

interface IInvoiceGenerationModalProps {
  isOpen: boolean;
  onClose: () => void;
  invoiceId: number;
}

export const InvoiceGenerationModal: React.FC<IInvoiceGenerationModalProps> = (props) => {
  const { isOpen, onClose, invoiceId } = props;

  const { t } = useTranslation('invoice');
  const downloadFile = useDownloadFile();

  const { mutateAsync: generateInvoice, isLoading } = useGenerateInvoice(invoiceId);

  const handleOk = debounce(async () => {
    const result = await generateInvoice();
    if (result) {
      downloadFile(result?.url);
    }
    onClose();
  }, 300);

  return (
    <Modal
      title={t('generate_new_invoice')}
      open={isOpen}
      confirmLoading={isLoading}
      onCancel={onClose}
      onOk={handleOk}
    />
  );
};
